export function isMac(): boolean {
  if (typeof navigator === "undefined") return false;

  // Modern API
  if ("userAgentData" in navigator) {
    return (navigator as { userAgentData?: { platform?: string } }).userAgentData?.platform === "macOS";
  }

  return /Mac|iPhone|iPad|iPod/.test(navigator.platform);
}

export function getShortcutLabel(key: string): string {
  return isMac() ? `\u2318${key}` : `Ctrl+${key}`;
}
